import _ from 'lodash';
import React, { Component } from 'react';
import { dp, parseTextStyling } from '../../../utils/shared';
import { DEFAULT_CYCLE, LOREM_IPSUM } from './AlbuquerqueConstants';

class AlbuquerqueStorySingleImage extends Component {
  constructor(props) {
    super(props);
    this._cycleTimeoutHandler = null;
  }
  
  componentDidMount() {
    this.setupCycle();
  }

  componentWillUnmount() {
    clearTimeout(this._cycleTimeoutHandler);
  }

  setupCycle = () => {
    const time = _.get(this.props.module, "contents.custom_fields.cycle_time.val", DEFAULT_CYCLE);
    this._cycleTimeoutHandler = setTimeout(() => {
      this.props.cycle();
    }, time * 1000)
  }

  getBackground = (i = 0) => {
    let imgObj = _.get(this.props.module, `contents.images[${i}]`, null);
    if (imgObj) {
      return dp(this.props.screen, imgObj, null);
    }
    return null;
  }

  render() {
    const headline = _.get(this.props.module, 'contents.custom_fields.headline.val', "Headline");
    const body = _.get(this.props.module, 'contents.custom_fields.body.val', LOREM_IPSUM);
    const headlineRawStyle = _.get(this.props.module, 'contents.custom_fields.headline_style', null);
    const bodyRawStyle = _.get(this.props.module, 'contents.custom_fields.body_style', null);
    const headlineStyle = parseTextStyling(headlineRawStyle);
    const bodyStyle = parseTextStyling(bodyRawStyle);
    const image = this.getBackground();

    return (
      <div>
        {/* <div style={{ position: "absolute", width: "100%", height: "100%", opacity: OPACITY_PERCENTAGE, backgroundColor: OPACITY_COLOR }}/> */}
        <div style={{ position: "absolute", width: "100%", height: "50vh", top:"25vh", display: "table" }}>
          <div style={{ display: "table-cell", padding: "0 10% 0 10%", verticalAlign: "middle" }}>
            <div style={{ display: "table-cell", width: "50%", padding: "0 4% 0 4%" }}>
              <div style={{height: '52vh', display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'flex-end'}}>
                <img style={{maxHeight: '100%', maxWidth: '100%'}} src={image} role='presentation'/>
              </div>
            </div>
            <div style={{ display: "table-cell", width: "50%", verticalAlign: "top" }}>
              <div style={{ display: "table-cell" }}>
                <div style={{ ...headlineStyle, fontFamily: "legacysans-bold" }}>{headline}</div>
                <br/>
                <div style={{ ...bodyStyle, fontFamily: "legacysans-book" }}>{body}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AlbuquerqueStorySingleImage;


// WEBPACK FOOTER //
// ./src/Components/Theme/Albuquerque/AlbuquerqueStorySingleImage.jsx